EMMY.financeAdmin = {
  init: function () {

    EMMY.financeAdmin.financeAdminTabs();

  },
  financeAdminTabs: function() {
    // console.log('binding');
    $('.accordion-tabs .tab-link').first().addClass('is-active');
    $('.accordion-tabs .tab-contents').first().show();
    $('.accordion-tabs .tab-contents').slice(1).hide();

    $('.accordion-tabs').on('click', 'a', function(event) {
      if (!$(this).hasClass('is-active')) {
        event.preventDefault();

        $('.accordion-tabs .tab-link').each(function(index) {
          $(this).toggleClass('is-active');
        });

        $('.accordion-tabs .tab-contents').each(function(index) {
          $(this).toggle();
        });


      } else {
        event.preventDefault();
      }
    });
  }
};
